enum ItemType {
    CHECKLIST = 0,
    COMMENT = 1,
    IMAGE = 2,
    OBSERVATION = 3,
}

export default ItemType;